import UpcomingWorkshopEvents from 'components/UpcomingWorkshopEvents';
import WorkshopList from 'components/WorkshopList';
import Countdown from 'components/CountdownTimer';

export default {
  Countdown,
  UpcomingWorkshopEvents,
  WorkshopList,
};
